import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the salesforceVerify state domain
 */

const selectSalesforceVerifyDomain = state => state.salesforceVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(
    selectSalesforceVerifyDomain,
    subState => subState.isVerify
  );

const makeSelectError = () =>
  createSelector(
    selectSalesforceVerifyDomain,
    subState => subState.error
  );

export { makeSelectIsVerify, makeSelectError };
